// hooks
import useAuth from '../hooks/useAuth';
//
import { MAvatar } from './@material-extend';
import { MAvatarProps } from './@material-extend/MAvatar';
import createAvatar from '../utils/createAvatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }: MAvatarProps) {
  const { user } = useAuth();

  return (
    <MAvatar
      src={user?.avatar || ''}
      alt={user.name}
      color={createAvatar(user.name).color}
      {...other}
    >
      {createAvatar(user.name || user.email).name}
    </MAvatar>
  );
}
